import { func, instanceOf, shape, string } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import withResolved from '../../REST/with-resolved';
import createModalToggle from '../create-modal-toggle';

function FilePreviewComponent({ toggle, file, title }) {
  return (
    <>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <div style={{ height: '70vh' }}>
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            title={title}
            src={URL.createObjectURL(file.data)}
          >
            Your browser does not support previewing this file
          </iframe>
        </div>
      </ModalBody>
    </>
  );
}

FilePreviewComponent.propTypes = {
  file: shape({ data: instanceOf(Blob).isRequired }).isRequired,
  toggle: func.isRequired,
  title: string.isRequired,
};

const FilePreviewWithData = withResolved({
  as: 'file',
  deriveQueryArgs: props => props.queryFn,
  query: function filePreviewQuery(queryFn) {
    return queryFn();
  },
})(FilePreviewComponent);

const FilePreview = createModalToggle(
  'Preview',
  FilePreviewWithData,
  { color: 'secondary' },
  { size: 'xl', className: 'modal-dialog-scrollable' },
);

FilePreview.propTypes = {
  queryFn: func.isRequired,
  title: string.isRequired,
};

export default FilePreview;
